import { render, staticRenderFns } from "./m-form-change-password.vue?vue&type=template&id=56473754&scoped=true&lang=pug&"
import script from "./m-form-change-password.vue?vue&type=script&lang=js&"
export * from "./m-form-change-password.vue?vue&type=script&lang=js&"
import style0 from "./m-form-change-password.vue?vue&type=style&index=0&id=56473754&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56473754",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VForm } from 'vuetify/lib/components/VForm';
installComponents(component, {VBtn,VForm})
